import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: {}
}

const {reducer, actions} = createSlice({
  initialState,
  name: 'info',
  reducers: {
    reset: () => initialState,
    update: (state, action) => {
      state.data = action.payload
    },
  }
});

export { actions, reducer }
export default reducer
